export const ICONFERENCE = '/iconference'
export const ICONFERENCE_SITE_CONTENT = `${ICONFERENCE}/site-content`
export const ICONFERENCE_CREATE_PAGE = `${ICONFERENCE_SITE_CONTENT}/new`
export const ICONFERENCE_VIEW_PAGE = `${ICONFERENCE_SITE_CONTENT}/:id`
export const ICONFERENCE_ARTICLE_SUBMISSION_MANAGEMENT = `${ICONFERENCE}/submission-management`
export const ICONFERENCE_ARTICLE_SUBMISSION_MANAGEMENT_BY_ID = `${ICONFERENCE}/submission-management/:id`
export const ICONFERENCE_MAGAZINE_DESIGNER = `${ICONFERENCE}/for-designers`
